import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const Bold = styled.span`
  font-weight: 700;
`;

const Card = styled.div``;

const CardContent = styled.div`
  padding: 24px;
`;

const CardHeader = styled.div`
  align-items: center;
  border-bottom: 1px solid var(--color-accent-secondary-weaker);
  display: flex;
  gap: 8px;
  padding: 20px 16px;
`;

const Content = styled.div``;

const Description = styled(Typography)`
  margin-top: 24px;
`;

const ItemHelpText = styled.div`
  color: var(--color-neutral-300);
  font-size: 14px;
`;

const ItemLabel = styled.div``;

const LeftContent = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  flex-grow: 1;
  padding: 16px;
`;

const PriceLabel = styled.div`
  font-weight: 700;
`;

const PriceSummary = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  height: fit-content;
  min-width: 432px;
  padding: 16px;
`;

const PriceSummaryInfo = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 16px 0 8px;
`;

const RowTitle = styled.div``;

const CollectionsDetail = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 16px;
`;

const CollectionsWarningList = styled.ul`
  padding: 0 16px;
`;

const CollectionsWarningListItem = styled.li`
  list-style-type: disc;
`;

export {
  Bold,
  Card,
  CardContent,
  CardHeader,
  CollectionsDetail,
  CollectionsWarningList,
  CollectionsWarningListItem,
  Content,
  Description,
  ItemHelpText,
  ItemLabel,
  LeftContent,
  PriceLabel,
  PriceSummary,
  PriceSummaryInfo,
  RowTitle
};
